import React from 'react';
import { Icon, Row, Text, Accordion } from '../../../../../../../components/common';
import OrderItemsDetailTab from '../../../../../../../components/sections/Orders/OrderItemsDetailTabs';

export const PickingResult = ({ pickingResultAllowed, data, orderId, salesChannelId }) => {
    if (!pickingResultAllowed) return null;

    return (<Accordion
        title={<Row align='center' gap={15}>
            <Icon name='cart' color='#1FA02E' size={16} />
            <Text strong text='Resultado de picking' />
        </Row>}
        iconOpened='chebron_down'
        iconClosed='chebron_up'
        iconSize={10}
        styleHeader={{ borderRadius: 8 }}
        background='white'
        closedBackground='white'
        style={{ boxShadow: '0px 4px 12px 0px #00000014', margin: '0px 0px 15px 0px', borderRadius: 8 }}
    >
        <OrderItemsDetailTab
            skipQuery
            orderId={orderId}
            salesChannelId={salesChannelId}
            dataFromParent={data}
        />
    </Accordion>);
};

export default PickingResult;